<section class="page-title-area">
  <div class="container">
    <div class="page-title-content" *ngFor="let pageTitle of pageTitleArea">
      <h2>{{ pageTitle.title }}</h2>
      <ul>
        <li><a routerLink="/">Home</a></li>
        <li>{{ pageTitle.title }}</li>
        <li>{{ pageTitle.subTitle }}</li>
      </ul>
    </div>
  </div>

  <div class="shape-img1">
    <img src="assets/img/shape/shape1.svg" alt="image" />
  </div>
  <div class="shape-img2">
    <img src="assets/img/shape/shape2.png" alt="image" />
  </div>
  <div class="shape-img3">
    <img src="assets/img/shape/shape3.png" alt="image" />
  </div>
</section>

<section class="case-studies-details-area pb-100">
  <div class="container">
    <div class="row" *ngIf="editsuccess == false">
      <!--TODO THIS SHOULD HAVE A COMPONENT ROUTE OF IT'S OWN-->
      <div
        *ngIf="this.pageData === 'success-stories-details' && !isHardCodedStory"
        class="col-lg-12 col-md-12">
        <div class="case-studies-details-image">
          <img [src]="mainimage" alt="image" />
        </div>

        <div class="case-studies-details-desc">
          <span style="text-align: center" class="sub-title">
            {{ stories.title }}
          </span>
          <h3>Business Challenge</h3>
          <p [innerHTML]="stories.business_challenges"></p>
          <h3>Solution</h3>
          <p [innerHTML]="stories.solutions"></p>
          <h3>Benefits & Results</h3>
          <p [innerHTML]="stories.benefits_results"></p>
          <div class="display-grid">
            <div>
              <h6>
                Created by
                <i
                  class="fa fa-info-circle"
                  matTooltip="Name of the person who create the success story"></i>
              </h6>
              <span class="sub-title">{{ stories.post_by.displayName }}</span>
              <h6>
                Created date
                <i class="fa fa-info-circle" matTooltip="Format MM-DD-YYYY"></i>
              </h6>
              <span class="sub-title">{{ stories.post_date }}</span>
            </div>
            <div class="display-gridright">
              <h6 *ngIf="stories.last_modified_by?.displayName !== null">
                Modified By
                <i
                  class="fa fa-info-circle"
                  matTooltip="Name of the person who modify the success story"></i>
              </h6>
              <span
                class="sub-title"
                *ngIf="stories.last_modified_by?.displayName !== null">
                {{ stories.last_modified_by.displayName }}
              </span>
              <h6 *ngIf="stories.last_modified_by?.displayName !== null">
                Modified date
                <i class="fa fa-info-circle" matTooltip="Format MM-DD-YYYY"></i>
              </h6>
              <span
                class="sub-title"
                *ngIf="stories.last_modified_by?.displayName !== null">
                {{ stories.last_modified_date }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <!--TODO THIS SHOULD HAVE A COMPONENT ROUTE OF IT'S OWN-->
      <div
        *ngIf="this.pageData === 'success-stories-details' && isHardCodedStory"
        class="col-lg-12 col-md-12">
        <div
          class="case-studies-details-image"
          *ngFor="let Image of caseStudiesDetailsImage">
          <img [src]="Image.img" alt="image" />
        </div>

        <div
          class="case-studies-details-desc"
          *ngFor="let DetailsDesc of caseStudiesDetailsDesc">
          <span class="sub-title">{{ DetailsDesc.subTitle }}</span>
          <h3>{{ DetailsDesc.title1 }}</h3>
          <p [innerHTML]="DetailsDesc.paragraph1"></p>

          <h3>{{ DetailsDesc.title2 }}</h3>
          <p [innerHTML]="DetailsDesc.paragraph2"></p>
          <h3>{{ DetailsDesc.title3 }}</h3>
          <p [innerHTML]="DetailsDesc.paragraph3"></p>
          <h3>{{ DetailsDesc.title4 }}</h3>
          <p [innerHTML]="DetailsDesc.paragraph4"></p>
          <h3>{{ DetailsDesc.title5 }}</h3>
          <p [innerHTML]="DetailsDesc.paragraph5"></p>
          <h3>{{ DetailsDesc.title6 }}</h3>
          <p [innerHTML]="DetailsDesc.paragraph6"></p>
          <h3>{{ DetailsDesc.title7 }}</h3>
          <p [innerHTML]="DetailsDesc.paragraph7"></p>
          <h3>{{ DetailsDesc.title8 }}</h3>
          <p [innerHTML]="DetailsDesc.paragraph8"></p>
          <div class="row align-items-center">
            <div Gastostyle="display:flex;justify-content:center;">
              <div class="image">
                <img [src]="DetailsDesc.img1" alt="image" />
              </div>
            </div>

            <!-- <div class="col-lg-6 col-md-6">
                            <div class="content">
                                <h3>{{DetailsDesc.title2}}</h3>
                                <ul>
                                    <li *ngFor="let ImportantFacts of caseStudiesDetailsDescImportantFacts;">{{ImportantFacts.title}}</li>
                                </ul>
                            </div>
                        </div> -->
          </div>
        </div>
      </div>
      <!--TODO THIS SHOULD HAVE A COMPONENT ROUTE OF IT'S OWN-->
      <div
        *ngIf="
          this.pageData === 'data-foundation-architecture' ||
          this.pageData === 'data-foundation-governance' ||
          this.pageData != 'success-stories-details'
        "
        class="col-lg-12 col-md-12">
        <div
          class="case-studies-details-image"
          *ngFor="let Image of caseStudiesDetailsImage">
          <img [src]="Image.img" alt="image" />
        </div>

        <div
          class="case-studies-details-desc"
          *ngFor="let DetailsDesc of caseStudiesDetailsDesc">
          <span class="sub-title">{{ DetailsDesc.subTitle }}</span>
          <h3>{{ DetailsDesc.title1 }}</h3>
          <p [innerHTML]="DetailsDesc.paragraph1"></p>

          <h3>{{ DetailsDesc.title2 }}</h3>
          <p [innerHTML]="DetailsDesc.paragraph2"></p>
          <h3>{{ DetailsDesc.title3 }}</h3>
          <p [innerHTML]="DetailsDesc.paragraph3"></p>
          <h3>{{ DetailsDesc.title4 }}</h3>
          <p [innerHTML]="DetailsDesc.paragraph4"></p>
          <h3>{{ DetailsDesc.title5 }}</h3>
          <p [innerHTML]="DetailsDesc.paragraph5"></p>
          <h3>{{ DetailsDesc.title6 }}</h3>
          <p [innerHTML]="DetailsDesc.paragraph6"></p>
          <h3>{{ DetailsDesc.title7 }}</h3>
          <p [innerHTML]="DetailsDesc.paragraph7"></p>
          <h3>{{ DetailsDesc.title8 }}</h3>
          <p [innerHTML]="DetailsDesc.paragraph8"></p>
          <div class="row align-items-center">
            <div
              *ngIf="this.pageData === 'data-foundation-governance'"
              style="display: flex; justify-content: center">
              <div class="image">
                <img [src]="DetailsDesc.img1" alt="image" />
              </div>
            </div>

            <!-- <div class="col-lg-6 col-md-6">
                            <div class="content">
                                <h3>{{DetailsDesc.title2}}</h3>
                                <ul>
                                    <li *ngFor="let ImportantFacts of caseStudiesDetailsDescImportantFacts;">{{ImportantFacts.title}}</li>
                                </ul>
                            </div>
                        </div> -->
          </div>
        </div>
      </div>
      <!--TODO THIS SHOULD HAVE A COMPONENT ROUTE OF IT'S OWN-->
      <div
        *ngIf="
          this.pageData != 'data-foundation-architecture' &&
          this.pageData != 'data-foundation-governance' &&
          this.pageData != 'success-stories-details'
        "
        class="col-lg-8 col-md-12">
        <div
          class="case-studies-details-image"
          *ngFor="let Image of caseStudiesDetailsImage">
          <img [src]="Image.img" alt="image" />
        </div>

        <div
          class="case-studies-details-desc"
          *ngFor="let DetailsDesc of caseStudiesDetailsDesc">
          <span class="sub-title">{{ DetailsDesc.subTitle }}</span>
          <h3>{{ DetailsDesc.title1 }}</h3>
          <p>{{ DetailsDesc.paragraph1 }}</p>

          <div class="row align-items-center">
            <div class="col-lg-6 col-md-6">
              <div class="image">
                <img [src]="DetailsDesc.img1" alt="image" />
              </div>
            </div>

            <div class="col-lg-6 col-md-6">
              <div class="content">
                <h3>{{ DetailsDesc.title2 }}</h3>
                <ul>
                  <li
                    *ngFor="
                      let ImportantFacts of caseStudiesDetailsDescImportantFacts
                    ">
                    {{ ImportantFacts.title }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <p>{{ DetailsDesc.paragraph2 }}</p>
          <h3>{{ DetailsDesc.title3 }}</h3>
          <p>{{ DetailsDesc.paragraph3 }}</p>
          <div>{{ DetailsDesc.paragraph4 }}</div>
        </div>
      </div>
      <!--TODO THIS SHOULD HAVE A COMPONENT ROUTE OF IT'S OWN-->
      <div
        *ngIf="
          this.pageData != 'data-foundation-architecture' &&
          this.pageData != 'success-stories-details' &&
          this.pageData != 'data-foundation-governance'
        "
        class="col-lg-4 col-md-12">
        <div class="case-studies-sidebar-sticky">
          <div class="case-studies-details-info">
            <ul>
              <li *ngFor="let Info of caseStudiesDetailsInfo">
                <div class="icon">
                  <i class="{{ Info.icon }}"></i>
                </div>
                <span>{{ Info.title }}:</span>
                {{ Info.subTitle }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<app-related-case-studies
  *ngIf="this.pageData != 'success-stories-details'"></app-related-case-studies>
